import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { LaunchCampaignTemplate } from "~/features/launchCampaign/LaunchCampaignTemplate";

/**
 * 動画のあとに進む先。**この画面へ横取りされる前に行こうとしていた場所**が入る
 * （誘導は `_authenticated` の beforeLoad ゲート）。
 *
 * ★内部パスだけ受ける。`//` で始まる値は外部URLとして解釈されるため弾く。
 *   search はURLから誰でも書き換えられるので、ここを緩めると外部サイトへ飛ばせてしまう。
 * ★自分自身は受けない（動画から動画へ戻って抜けられなくなる）。
 */
const launchCampaignSearchSchema = z.object({
  next: z
    .string()
    .refine(
      (v) =>
        v.startsWith("/") && !v.startsWith("//") && v !== "/launch-campaign",
      { message: "内部パスのみ" },
    )
    .optional(),
});

// 表示可否（このセッション/当日にまだ未表示か）の判定と /launch-campaign への誘導は
// `_authenticated` の beforeLoad ゲートに一本化する。
// ここ（子ルート）で beforeLoad ガードを持つと、画面マウント時の mark で「表示済み」に変わった後の
// beforeLoad 再評価が自分自身を /discover へ redirect してしまい、動画が一瞬で消える不具合になる。
export const Route = createFileRoute("/_authenticated/launch-campaign")({
  validateSearch: launchCampaignSearchSchema,
  component: LaunchCampaignTemplate,
});
